import React from "react";

import { parseDocType } from "EmployerApplication/Components/documentPicker/utils";

import BodyText from "Common/BodyText";
import { Ol } from "Common/HTML";

import type { UploadDocsProp } from "Utils/types";

export const primepayDocsDescription = (props: UploadDocsProp) => {
  const docType = parseDocType(props.fileInputName);

  switch (docType) {
    case "state_wage_report":
      return <StateWageReport {...props} />;
    case "payroll_journal":
      return <PayrollJournal {...props} />;
    default:
      return props.description;
  }
};

const StateWageReport = () => (
  <BodyText>
    Within{" "}
    <a href="https://u-sso.primepay.com" target="_blank" rel="noreferrer">
      https://u-sso.primepay.com
    </a>
    :
    <Ol my={2}>
      <li>
        From the Top menu, select{" "}
        <BodyText componentClass="span" weight="bold">
          Reports
        </BodyText>
        .
      </li>
      <li>
        Click on the{" "}
        <BodyText componentClass="span" weight="bold">
          Tax Forms
        </BodyText>{" "}
        Tab.
      </li>
      <li>Find your form in the list.</li>
      <li>Select your form. Make sure that the document you select is from the correct quarter, and also is not the federal 941 form.</li>
      <li>
        Click the{" "}
        <BodyText componentClass="span" weight="bold">
          Download
        </BodyText>{" "}
        Button
      </li>
    </Ol>
    After downloading the PDF file, upload it here by clicking the input field below.
  </BodyText>
);

const PayrollJournal = () => (
  <BodyText>
    Within{" "}
    <a href="https://u-sso.primepay.com" target="_blank" rel="noreferrer">
      https://u-sso.primepay.com
    </a>
    :
    <Ol my={2}>
      <li>
        From the Top menu, select{" "}
        <BodyText componentClass="span" weight="bold">
          Reports
        </BodyText>
        .
      </li>
      <li>
        Click on the{" "}
        <BodyText componentClass="span" weight="bold">
          Payroll
        </BodyText>{" "}
        Tab.
      </li>
      <li>
        Select{" "}
        <BodyText componentClass="span" weight="bold">
          Payroll Journal
        </BodyText>{" "}
        from the drop-down.
      </li>
      <li>
        Click the
        <BodyText componentClass="span" weight="bold">
          Download
        </BodyText>{" "}
        Button
      </li>
      <li>
        Now select the{" "}
        <BodyText componentClass="span" weight="bold">
          Downloads
        </BodyText>
        tab.
      </li>
      <li>
        After the report is generated, select{" "}
        <BodyText componentClass="span" weight="bold">
          Download
        </BodyText>{" "}
        The report will appear in a zip document.
      </li>
      <li>Unzip the file, and select the pdf file within.</li>
    </Ol>
    After unzipping the report as PDF, upload it here by clicking the input field below.
  </BodyText>
);
